import { toast } from 'sonner';
import i18n from '../config/i18n';

const COOLDOWN_MS = 30_000;
let lastToastAt = 0;

export function notifyDataUnavailable(message?: string) {
  const now = Date.now();
  if (now - lastToastAt < COOLDOWN_MS) {
    return;
  }
  lastToastAt = now;
  const fallback = 'Some data is temporarily unavailable.';
  const text =
    message ??
    i18n.t('common.dataUnavailable', {
      defaultValue: fallback,
    });
  toast.error(text);
}
